module.exports = __webpack_public_path__ + "static/media/Pineapple.5fdc65e5.png";